/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface ContactPost
 */
export interface ContactPost {
  /**
   *
   * @type {number | null}
   * @memberof ContactPost
   */
  companyId?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  companyName?: string | null;
  /**
   *
   * @type {Date | null}
   * @memberof ContactPost
   */
  dateModified?: Date | null;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  email?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof ContactPost
   */
  emails?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  firstName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  jobTitle?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  lastName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  name?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof ContactPost
   */
  phoneNumber?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof ContactPost
   */
  phones?: Array<any>;
}

/**
 * Check if a given object implements the ContactPost interface.
 */
export function instanceOfContactPost(value: object): value is ContactPost {
  return true;
}

export function ContactPostFromJSON(json: any): ContactPost {
  return ContactPostFromJSONTyped(json, false);
}

export function ContactPostFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ContactPost {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    companyName:
      json['company_name'] == null ? undefined : json['company_name'],
    dateModified:
      json['date_modified'] == null
        ? undefined
        : new Date(json['date_modified']),
    email: json['email'] == null ? undefined : json['email'],
    emails: json['emails'] == null ? undefined : json['emails'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    jobTitle: json['job_title'] == null ? undefined : json['job_title'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    name: json['name'] == null ? undefined : json['name'],
    phoneNumber:
      json['phone_number'] == null ? undefined : json['phone_number'],
    phones: json['phones'] == null ? undefined : json['phones'],
  };
}

export function ContactPostToJSON(value?: ContactPost | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    company_name: value['companyName'],
    date_modified:
      value['dateModified'] == null
        ? value['dateModified']
        : (value['dateModified'] as any).toISOString(),
    email: value['email'],
    emails: value['emails'],
    first_name: value['firstName'],
    job_title: value['jobTitle'],
    last_name: value['lastName'],
    name: value['name'],
    phone_number: value['phoneNumber'],
    phones: value['phones'],
  };
}
